export const ClassUpsellSignupDto = {
    GROUP: 'GROUP',
    PRIVATE: 'PRIVATE',
};



// WEBPACK FOOTER //
// ./ts/app/shared/types/ClassUpsellSignupDto.ts